import React, { memo } from "react";
import {
  Stack,
  Typography,
  CardContent,
  Card,
  Chip,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "investira.react.components";
import { HighchartsReact } from "investira.react.charts";

const AtivoCarteira = memo((props) => {
  const { pessoa, ativo } = props;

  if (process.env.NODE_ENV === "production") {
    return null;
  }

  if (!["FND"].includes(ativo.mercado)) {
    return null;
  }

  // if (["ACN", "CTIM"].includes(ativo.ativo_tipo_id)) {
  //   return null;
  // }

  const xOptions = {
    chart: {
      type: "pie",
    },
    title: false,
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.y:.1f}%",
        },
      },
    },
    series: [
      {
        name: "Main Categories",
        colorByPoint: true,
        data: [
          {
            name: "Cotas de Fundo",
            y: 35,
            drilldown: "category-a",
          },
          {
            name: "Valores a pagar",
            y: 35,
            drilldown: "category-b",
          },
          {
            name: "Valores a receber",
            y: 30,
            drilldown: "category-c",
          },
        ],
      },
    ],
    drilldown: {
      series: [
        {
          id: "category-a",
          name: "Cotas de Fundo",
          data: [
            ["Sub A1", 30],
            ["Sub A2", 25],
          ],
        },
        {
          id: "category-b",
          name: "Valores a pagar",
          data: [
            ["Sub B1", 20],
            ["Sub B2", 15],
            ["Sub B3", 10],
          ],
        },
        {
          id: "category-c",
          name: "Valores a receber",
          data: [
            ["Sub C1", 20],
            ["Sub C2", 15],
            ["Sub C3", 10],
          ],
        },
      ],
    },
  };

  return (
    <Stack flexGrow={1}>
      <Card>
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Stack spacing={2} sx={{ py: 2 }}>
            <Stack>
              <Typography
                variant="subtitle1"
                color="textPrimary"
                sx={{ fontWeight: 600 }}
              >
                Composição da Carteira
              </Typography>
            </Stack>
            {/* Aqui entra os ativos */}
            <Stack direction="row" spacing={1}>
              <Chip
                label={ativo.ticker || ativo.ativo}
                variant="outlined"
                color="primary"
                size="small"
              />
            </Stack>
            <Stack direction="row" sx={{ gap: 3 }}>
              <Stack flexGrow={0}>
                <HighchartsReact options={xOptions} drilldown />
              </Stack>
              <Stack flexGrow={1} direction="column">
                <Stack>
                  <Typography variant="h6">Setembro 2024</Typography>
                </Stack>
                <Stack flexGrow={1}>
                  <Table sx={{ width: "100%" }}>
                    <TableBody>
                      <TableRow>
                        <TableCell>Cotas de Fundo</TableCell>
                        <TableCell>99,90%</TableCell>
                        <TableCell>R$ 100 mil</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Valores a pagar</TableCell>
                        <TableCell>99,90%</TableCell>
                        <TableCell>R$ 100 mil</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Valores a receber</TableCell>
                        <TableCell>99,90%</TableCell>
                        <TableCell>R$ 100 mil</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan="3">
                          <Button variant="contained" fullWidth>
                            Ver carteira completa
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
});

export default AtivoCarteira;
